export default "__VITE_ASSET__3687d076__"